module.exports = __webpack_public_path__ + "static/media/rsz_monstersr2.9fa0a518.webp";